import _defineProperty from "@babel/runtime/helpers/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import cc from 'classcat';
import PropTypes from 'prop-types';
import React from 'react';
import Image from '../Image';
import css from './FabricDescription.module.scss';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";

var FabricDescription = function FabricDescription(_ref) {
  var description = _ref.description,
      image = _ref.image,
      title = _ref.title;
  return /*#__PURE__*/_jsxs("section", {
    className: css.root,
    children: [/*#__PURE__*/_jsx(Image, _objectSpread(_objectSpread({}, image), {}, {
      className: cc([css.image, css.desktop])
    })), /*#__PURE__*/_jsxs("div", {
      className: css.copy,
      children: [/*#__PURE__*/_jsx("h2", {
        className: css.title,
        dangerouslySetInnerHTML: {
          __html: title
        }
      }), /*#__PURE__*/_jsx(Image, _objectSpread(_objectSpread({}, image), {}, {
        className: cc([css.image, css.mobile])
      })), /*#__PURE__*/_jsx("p", {
        className: css.description,
        children: description
      })]
    })]
  });
};

FabricDescription.propTypes = {
  description: PropTypes.string.isRequired,
  image: PropTypes.shape({
    alt: PropTypes.string.isRequired,
    src: PropTypes.string.isRequired
  }).isRequired,
  title: PropTypes.string.isRequired
};
export default FabricDescription;